export default "__VITE_ASSET__DCqAAH5J__"